{
	"billedAnnually": "Billed annually",
	"billedMonthly": "Billed monthly",
	"billedMonthlyShort": "Billed monthly.",
	"billedYearly": "{{cost}} billed yearly.",
	"cancelSubscription": "Cancel Subscription",
	"currentPlan": "Current Plan",
	"expiringAt": "Expiring at {{date}}",
	"exportExplanation": "An export is an unique photo coming out of {{productName}} to your file system. Pay as you go exports never expire and are only used after subscription exports are exhausted. Subscriptions are not refundable. Subscriptions are automatically charged at the beginning of each billing cycle unless cancelled. Subscription credits expire at the end of each subscription billing cycle and do not rollover to the next cycle.",
	"featureAiCropMask": "AI Crop, Straighten, Mask",
	"featureAiCulling": "AI Culling",
	"featureAiEditing": "AI Editing",
	"featureAiRemoval": "AI Removal - 250 monthly",
	"featurePersonalStyles": "Personal AI Styles",
	"featurePhotoEditor": "Professional Photo Editor",
	"featurePhotoExports": "Photo Exports - Unlimited",
	"perMonth": "/mo",
	"renewSubscription": "Renew Subscription",
	"subscribe": "Subscribe",
	"switchPlan": "Switch to this plan",
	"unlimitedAiEdits": "AI edits",
	"unlimitedExports": "exports.",
	"tabMonthly": "MONTHLY",
	"tabYearly": "YEARLY",
	"unlimited": "Unlimited"
}
